import React, { useState, useEffect } from "react";
import api from "../../../services/api";
import DateRangePicker from "../../../components/ui/components/DateRangePicker";
import styles from "./TrackingPage.module.css";

export default function TrackingPage() {
  const [range, setRange] = useState({ from: null, to: null });
  const [drivers, setDrivers] = useState([]);
  const [loaders, setLoaders] = useState([]);
  const [loading, setLoading] = useState(false);
  const [rawData, setRawData] = useState(null);

  // Загружаем сотрудников через /analytics
  async function loadStaff() {
    if (!range.from || !range.to) return;
    setLoading(true);
    try {
      const payload = {
        from: range.from,
        to: range.to,
      };

      // Используем существующий эндпоинт
      const res = await api.post("/analytics", payload);
      console.log("📊 Ответ /analytics:", res);

      const all = res || [];
      setRawData(all);

      // Фильтрация по роли
      setDrivers(all.filter(w => w.role === "Водитель"));
      setLoaders(all.filter(w => w.role === "Грузчик"));
    } catch (err) {
      console.error("❌ Ошибка загрузки данных трекинга:", err);
    } finally {
      setLoading(false);
    }
  }

  // Загружаем при изменении диапазона
  useEffect(() => {
    if (range.from && range.to) loadStaff();
  }, [range]);

  return (
    <div className={styles.page}>
      <header className={styles.header}>
        <h1>Трекинг сотрудников</h1>
        <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
          <DateRangePicker mode="range" onChange={setRange} />
          <small style={{ fontSize: 13, color: "#666" }}>
            Период: {range.from || "—"} — {range.to || "—"}
          </small>
        </div>
      </header>

      {loading && <p>Загрузка...</p>}

      {!loading && (
        <>
          {/* Лог ответа */}
          {rawData && (
            <details style={{ marginBottom: 20 }}>
              <summary style={{ cursor: "pointer", color: "#007bff" }}>
                📋 Посмотреть ответ /analytics
              </summary>
              <pre
                style={{
                  background: "#f8f8f8",
                  padding: "10px",
                  borderRadius: "8px",
                  fontSize: "13px",
                  maxHeight: "300px",
                  overflow: "auto",
                }}
              >
                {JSON.stringify(rawData, null, 2)}
              </pre>
            </details>
          )}

          <section>
            <h2>🚚 Водители</h2>
            {drivers.length === 0 ? (
              <p>Нет данных за выбранный период</p>
            ) : (
              <div className={styles.cards}>
                {drivers.map(d => (
                  <div key={d.name} className={styles.card}>
                    <h3>{d.name}</h3>
                    <p>{d.role}</p>
                  </div>
                ))}
              </div>
            )}
          </section>

          <section>
            <h2>📦 Грузчики</h2>
            {loaders.length === 0 ? (
              <p>Нет данных за выбранный период</p>
            ) : (
              <div className={styles.cards}>
                {loaders.map(l => (
                  <div key={l.name} className={styles.card}>
                    <h3>{l.name}</h3>
                    <p>{l.role}</p>
                  </div>
                ))}
              </div>
            )}
          </section>
        </>
      )}
    </div>
  );
}
